import { render, staticRenderFns } from "./AppAnomaliasGoogleMapsReview.vue?vue&type=template&id=2b0f275a&scoped=true&"
import script from "./AppAnomaliasGoogleMapsReview.vue?vue&type=script&lang=js&"
export * from "./AppAnomaliasGoogleMapsReview.vue?vue&type=script&lang=js&"
import style0 from "./AppAnomaliasGoogleMapsReview.vue?vue&type=style&index=0&id=2b0f275a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b0f275a",
  null
  
)

export default component.exports